import {Injectable} from '@angular/core';

import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import { IProduct, IRoom } from '../model/room.model';

@Injectable({providedIn: 'root'})
export class LiveService {

    private baseUrl;

    constructor(protected http: HttpClient) {
        this.baseUrl = environment.serviceUrl;
    }

    findByRoomId(roomId: string, projectId: string): Observable<HttpResponse<IRoom>> {
        const url = `${this.baseUrl}/shop/api/projects/${projectId}/streamer/rooms/${roomId}`;

        return this.http.get<IRoom>(url, {
            observe: 'response'
        });
    }

    patchByRoomId(request: any, projectId: string): Observable<HttpResponse<IRoom>> {
        const url = `${this.baseUrl}/shop/api/projects/${projectId}/streamer/rooms/patch`;
        return this.http.put<IRoom>(url, request, {
            observe: 'response'
        });
    }

    addProducts(roomId: string, projectId: string, products: IProduct[]): Observable<HttpResponse<IRoom>> {
        const url = `${this.baseUrl}/shop/api/projects/${projectId}/streamer/rooms/${roomId}/add-products`;
        return this.http.post<IRoom>(url, products, {
          observe: 'response'
        });
    }

    removeProducts(roomId: string, projectId: string, ids: {id: string}[]): Observable<HttpResponse<IRoom>> {
      const url = `${this.baseUrl}/shop/api/projects/${projectId}/streamer/rooms/${roomId}/remove-products`;
      return this.http.post<IRoom>(url, ids, {
        observe: 'response'
      });
    }

    getAllViewer(projectId: string, param: string): Observable<HttpResponse<IRoom[]>> {
        const url = `${this.baseUrl}/shop/api/projects/${projectId}/viewer/rooms?${param}`;

        return this.http.get<IRoom[]>(url, {
            observe: 'response'
        });
    }
}
